import '../themeDefaults';

export default ({ datepickerReact }) => ({
  alwaysStackCalendars: {
    '&$calendar': { margin: [0, 0, 20, 0] },
    '&$calendars': { display: 'block', margin: 0 },
  },
  calendar: { margin: [0, 20, 0, 0] },
  calendars: { display: 'flex', margin: [0, -20, 0, 0] },
  dateSelect: {
    ...datepickerReact.dateSelect,
  },
  endTime: {
    marginLeft: 4,
  },
  row: {
    alignItems: 'flex-end',
    display: 'flex',
    justifyContent: 'space-between',
    margin: [16, 0, 0, 0],
  },
  [`@media (max-width: ${datepickerReact.mobileBreakpoint}px)`]: {
    calendar: { margin: [0, 0, 20, 0] },
    calendars: { display: 'block !important', margin: '0 !important' },
  },
  startTime: {
    marginRight: 4,
  },
  weekNumbers: {
    padding: [20, 10],
  },
});
